<template>
  <div class="mains">
    <div class="campus">
      学生测试
      <span>></span>
      测试管理
      <span>></span>
      制作试题
    </div>
    <div class="student_test">

      <el-card>
        <div class="grid-content">
          <div class="rule">
            <div class="xiaoqu_1">制作习题</div>

          </div>
          <p class="tishi">
            <i>
              <img src="@/assets/img/education-manage/campus/shenzhong.png" alt />
            </i> 此页面为制作习题页面，您需要填入
          </p>
          <div class="form_1">
            <el-form ref="forms" :model="form" label-width="5.20833vw">
              <el-form-item label="习题标题">
                <el-input v-model="form.title" disabled placeholder="请输入习题标题" class="shurukuang">1222</el-input>
              </el-form-item>
              <el-form-item label="阅读原文">
                <el-input type="textarea" disabled v-model="form.content" class="xtfl" rows="5"></el-input>
              </el-form-item>
              <el-form-item label="习题类型" prop="name" class="xuanxiang">
                <el-select v-model="region" disabled placeholder="请选择题型">
                  <el-option label="单选题" value="单选题"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="习题范例" prop="desc">
                <div class="xtfl1">
                  <h3>what is that ?</h3>
                  <div class="example">
                    <span>A: apple</span>
                    <span>B: banana</span>
                    <span>C: pear</span>
                    <span>D: orange</span>
                  </div>
                  <div class="example_img">
                    <img src="../../../../assets/img/xitifanli.png" alt="">
                  </div>
                </div>

              </el-form-item>
              <el-form-item label="习题个数" class="xuanxiang">
                <el-select v-model="textContent" disabled placeholder="习题个数">
                  <el-option label="1" value="1"></el-option>
                  <el-option label="2" value="2"></el-option>
                </el-select>
                &nbsp;
                <el-button @click="lastTopic()" v-show="lastTopics">上一题</el-button>
                <el-button @click="nextTopic()" v-show="nextTopics">下一题</el-button>

              </el-form-item>

              <el-form-item label="习题题目" prop="name">
                <el-input type="textarea" disabled v-model="form.title1" class="xtfl" rows="5"></el-input>
              </el-form-item>
              <el-form-item label="选项个数" class="xuanxiang">
                <el-select v-model="value" disabled placeholder="选项个数">
                  <el-option label="1" value="1"></el-option>
                  <el-option label="2" value="2"></el-option>
                  <el-option label="3" value="3"></el-option>
                  <el-option label="4" value="4"></el-option>

                </el-select>
              </el-form-item>
              <el-form-item label="习题选项">
                <el-radio-group v-model="chooseListAnswer">
                  <div class="options">
                    <div class="options_left">
                      <p>A</p>
                      <el-radio v-model="radio1" :label="chooseList[0]" disabled class="options_left_radio">设为正确答案</el-radio>
                    </div>
                    <div class="options_right">
                      <el-input type="textarea" disabled v-model="form.desc1" rows="9" cols="85"></el-input>
                    </div>
                  </div>
                  <div class="options">
                    <div class="options_left">
                      <p>B</p>
                      <el-radio v-model="radio1" disabled :label="chooseList[1]" class="options_left_radio">设为正确答案</el-radio>
                    </div>
                    <div class="options_right">
                      <el-input type="textarea" disabled v-model="form.desc2" rows="9" cols="85"></el-input>
                    </div>
                  </div>
                  <div class="options">
                    <div class="options_left">
                      <p>C</p>
                      <el-radio v-model="radio1" disabled :label="chooseList[2]" class="options_left_radio">设为正确答案</el-radio>
                    </div>
                    <div class="options_right">
                      <el-input type="textarea" disabled v-model="form.desc3" rows="9" cols="85"></el-input>
                    </div>
                  </div>
                  <div class="options">
                    <div class="options_left">
                      <p>D</p>
                      <el-radio v-model="radio1" disabled :label="chooseList[3]" class="options_left_radio">设为正确答案</el-radio>
                    </div>
                    <div class="options_right">
                      <el-input type="textarea" disabled v-model="form.desc4" rows="9" cols="85"></el-input>
                    </div>

                  </div>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="添加标签" prop="name">
                <el-select v-model="labelName" disabled placeholder="选择标签">
                  <el-option label="等级一" value="等级一"></el-option>
                  <el-option label="等级二" value="等级二"></el-option>
                  <el-option label="等级三" value="等级三"></el-option>
                  <el-option label="等级四" value="等级四"></el-option>
                  <el-option label="等级五" value="等级五"></el-option>
                  <el-option label="等级六" value="等级六"></el-option>
                </el-select>
              </el-form-item>
              <div class="score">
                <el-form-item label="习题分数">
                  <el-input type="text" disabled v-model="form.scoreNumber" class="grade" rows="5" placeholder="5分"></el-input>
                </el-form-item>
                <el-form-item label="习题数量">
                  <el-input type="text" disabled v-model="form.questionCount" class="grade" rows="5" placeholder="20题"></el-input>
                </el-form-item>
                <el-form-item label="共计分数">
                  <el-input type="text" disabled v-model="form.scoreCount" class="grade" rows="5" placeholder="100分"></el-input>
                </el-form-item>
              </div>
              <el-form-item class="tijiao">
                <router-link to="/testmangement">
                  <el-button>返回</el-button>
                </router-link>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-card>
    </div>

  </div>

</template>
<script>
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
export default {
  components: { quillEditor },

  data() {
    return {
      form: {
        title: '',
        title1: '',
        content: '',
        questionCount: '',
        desc: '',
        leveName: '',
        questionCount: '',
        scoreCount: '',
        scoreNumber: '',
        desc1: '',
        desc2: '',
        desc3: '',
        desc4: '',
      },
      chooseList: [],
      chooseListAnswer: '',
      select: '单选题',
      value: '4',
      radio1: '',
      region: '单选题',
      textContent: '',
      labelName: '',
      lastTopics: true,
      nextTopics: true,
      topicId: '',
    };
  },
  created() {
    this.lookTest();
    this.lookChooseText();
  },
  methods: {
    //查询试题
    lookTest() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/exam/readGrade/text/' + this.$route.params.id,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        console.log(res, '查询试题内容');
        if (res.data.code == 0) {
          let data = res.data.data;
          this.form.title = data.title;
          this.form.content = data.content;
          this.form.questionCount = data.questionCount;
          // this.form.leveName = data.leveName;
          this.form.questionCount = data.questionCount;
          this.form.scoreCount = data.scoreCount;
          this.form.scoreNumber = this.form.scoreCount / this.form.questionCount;
          this.labelName = data.leveName;
          this.textContent = data.questionCount;
          if (this.form.questionCount === 1) {
            this.lastTopics = false;
            this.nextTopics = false;
          }
        }
        console.log(this.form.questionCount, '习题数量');
      });
    },
    //查看选择题及答案
    lookChooseText() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/exam/readGrade/question/' + this.$route.params.id + '/1',
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        console.log(res, '选择试题的习题');
        if (res.data.code === 0) {
          this.form.title1 = res.data.data.title;
          this.chooseList = res.data.data.answers;
          this.form.desc1 = this.chooseList[0].option;
          this.form.desc2 = this.chooseList[1].option;
          this.form.desc3 = this.chooseList[2].option;
          this.form.desc4 = this.chooseList[3].option;
          this.topicId = res.data.data.id;
          for (let i = 0; i < this.chooseList.length; i++) {
            if (this.chooseList[i].answer === 1) {
              this.chooseListAnswer = this.chooseList[i];
            }
          }
        }
      });
    },
    //上一题按钮
    lastTopic() {
      this.form.title1 = '';
      this.chooseList = [];
      this.form.desc1 = '';
      this.form.desc2 = '';
      this.form.desc3 = '';
      this.form.desc4 = '';
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/exam/readGrade/question/' + this.$route.params.id + '/1',
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        console.log(res, '选择试题的习题');
        if (res.data.code === 0) {
          this.form.title1 = res.data.data.title;
          this.chooseList = res.data.data.answers;
          this.form.desc1 = this.chooseList[0].option;
          this.form.desc2 = this.chooseList[1].option;
          this.form.desc3 = this.chooseList[2].option;
          this.form.desc4 = this.chooseList[3].option;
          for (let i = 0; i < this.chooseList.length; i++) {
            if (this.chooseList[i].answer === 1) {
              this.chooseListAnswer = this.chooseList[i];
            }
          }
        }
      });
    },
    //下一题按钮
    nextTopic() {
      this.form.title1 = '';
      this.chooseList = [];
      this.form.desc1 = '';
      this.form.desc2 = '';
      this.form.desc3 = '';
      this.form.desc4 = '';
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/exam/readGrade/question/' + this.$route.params.id + '/2',
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        console.log(res, '选择试题的习题');
        if (res.data.code === 0) {
          this.form.title1 = res.data.data.title;
          this.chooseList = res.data.data.answers;
          this.form.desc1 = this.chooseList[0].option;
          this.form.desc2 = this.chooseList[1].option;
          this.form.desc3 = this.chooseList[2].option;
          this.form.desc4 = this.chooseList[3].option;
          for (let i = 0; i < this.chooseList.length; i++) {
            if (this.chooseList[i].answer === 1) {
              this.chooseListAnswer = this.chooseList[i];
            }
          }
        }
      });
    },
  },
};
</script>

<style>
.mains {
  box-sizing: border-box;
}
.el-card_body {
  position: relative;
}
.tishi {
  position: absolute;
  width: 100%;
  top: 60px;
  left: 0;
  color: #f87e2e;
  background-color: #feefe5;
}
.tishi i {
  margin-left: 3.4375rem /* 55/16 */;
}
.form_1 {
  margin-top: 70px;
  margin-left: 273px;
}
.xiaoqu_1 {
  font-weight: 700;
}
.shurukuang {
  width: 560px;
}
.myQuillEditor {
  width: 46.875rem /* 750/16 */;
  /* height: 9.375rem 150/16; 200/16 */
}
.xtfl {
  width: 46.875rem /* 750/16 */;
}
.xtfl1 {
  width: 46.875rem /* 750/16 */;
  height: 12.5rem /* 200/16 */;
  border: 1px solid #cccccc;
}
.xtfl1 h3 {
  margin-left: 1.875rem /* 30/16 */;
  margin-top: 10px;
}
.example {
  margin-left: 1.875rem /* 30/16 */;
  margin-top: -20px;
}
.example span {
  display: inline-block;
  margin-right: 10px;
}
.example_img {
  margin-left: 1.875rem /* 30/16 */;
  width: 6.25rem /* 100/16 */;
  height: 6.25rem /* 100/16 */;
}
.options {
  display: flex;
  width: 46.875rem /* 750/16 */;
  height: 12.5rem /* 200/16 */;
  border: 1px solid #cccccc;
  margin-bottom: 20px;
}
.options_left {
  width: 130px;
  height: 100%;
  background-color: #cccccc;
  color: white;
  text-align: center;
}
.options_left p {
  font-size: 16px;
  margin-top: 70px;
}
.options_left_radio {
  color: #fff;
}
.addLable {
  width: 12.5rem /* 200/16 */;
  height: 2.25rem /* 36/16 */;
}
.btn_addlable {
  width: 6rem /* 96/16 */;
  height: 2.125rem /* 34/16 */;
  margin-left: 1.5625rem /* 25/16 */;
}
.el-textarea__inner {
  resize: none;
}
.score {
  display: flex;
}
.score > :nth-child(2) {
  margin: 0 110px 0 140px;
}
.grade {
  width: 6.25rem /* 100/16 */;
}
</style>
